import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { Result, Button, Input, Form } from 'antd';
import { EDIT_HEATMAPS } from 'shared/constants/permissions';
import { withProtocol } from 'shared/utils/url';
import EmbedMatomo from 'containers/Results/WebsiteResults/EmbedMatomo';
import useDataSource from 'hooks/useDataSource';
import Loading from 'components/Loading';
import NoMatch from 'containers/NoMatch';

const extraFields = `
  website {
    id
    url
    matomoId
    matomoHeatmap(hsrId: $matomoHsrId) {
      id
      matomoHsrId
      name
      samples
      hasScreenshot
    }
  }
`;

const Heatmap = () => {
  const match = useRouteMatch('/data-sources/:dataSourceId/hsr/heatmaps/:matomoHsrId');
  const { dataSource, loading, hasDataSourcePermission } = useDataSource({ extraFields: extraFields.replace('$matomoHsrId', match.params.matomoHsrId) });

  if (loading) {
    return <Loading />;
  }

  const heatmap = dataSource?.website?.matomoHeatmap;

  if (!heatmap) {
    return <NoMatch />;
  }

  const onScreenshot = async (values) => {
    const url = new URL(withProtocol(values.url));
    url.searchParams.set('extellio_hsr_screenshot', heatmap.matomoHsrId);
    window.open(url, '_blank');
  };

  const initialValues = { url: dataSource.website.url };

  if (!heatmap.hasScreenshot) {
    const [samples] = heatmap.samples;
    return (
      <Result
        status="info"
        title="Screenshot missing"
        extra={hasDataSourcePermission(EDIT_HEATMAPS) ? (
          <Form onFinish={onScreenshot} initialValues={initialValues}>
            {samples > 0 && (
              <p>{`You have collected ${samples} samples, but you need a screenshot of the page to view the results.`}</p>
            )}
            <p>
              Enter a url where the heatmap is active and our script is running.
              <br />
              You will get a message about capturing a screenshot in the bottom right corner.
            </p>
            <Form.Item name="url">
              <Input style={{ width: 400 }} />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">Open page</Button>
            </Form.Item>
          </Form>
        ) : (
          <>You don&apos;t have permission to add a screenshot.</>
        )}
      />
    );
  }

  const urlParams = {
    category: 'HeatmapSessionRecording_Heatmaps',
    subcategory: match.params.matomoHsrId,
  };

  return (
    <EmbedMatomo urlParams={urlParams} permission={EDIT_HEATMAPS} />
  );
};

export default Heatmap;
